<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Organization</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'adminOrganizationCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>
                
                <h4 class="page-title">
                    <router-link :to="{ name: 'adminOrganization' }">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Organization
                </h4>
            </div>
        </div>
    </div>

    <div>
        <div class="card card-loader d-flex" v-if="loadingInitial">
            <div class="justify-content-center">
                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2">Loading</p>
            </div>
        </div>
        <form @submit.prevent="submitForm()" v-else>
             <div class="card">
                <div class="card-body">
                    <div class="form-group" :class="{ 'is-invalid': $v.dataOrganization.code.$error }">
                        <label class="col-form-label text-left d-block">Code Organization</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama Organization" 
                        v-model.trim="$v.dataOrganization.code.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataOrganization.code.required">Nama Organization wajib diisi</div>
                    </div>
                    <div class="form-group" :class="{ 'is-invalid': $v.dataOrganization.name.$error }">
                        <label class="col-form-label text-left d-block">Nama Organization</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama Organization" 
                        v-model.trim="$v.dataOrganization.name.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataOrganization.name.required">Nama Organization wajib diisi</div>
                    </div>
                </div>
            </div>


            <button class="btn btn-success waves-effect waves-light mb-5" :disabled="loading">
                Simpan Organization
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>

            <br>
        </form>
    </div>

  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    const username = helpers.regex('username', /^[a-z0-9_]*$/)

    export default {
        data() {
            return {
                loadingInitial: true,
                loading: false,
                dataOrganization: {
                    code: '',
                    name: '',
                },
            };
        },
        validations() {
            return {
                dataOrganization: {
                    code: {
                        required
                    },
                    name: {
                        required
                    }
                }
            }
        },
        methods: {
            // SUBMIT FORM
            submitForm() {
                // IF VALIDATION INVALID
                if (this.$v.dataOrganization.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess
                let dataStored = {
                    code: this.dataOrganization.code,
                    name: this.dataOrganization.name
                }

                if(this.$route.name == 'adminOrganizationCreate') {
                    url = `administrator/organization`
                    method = 'POST'
                    alertSuccess = 'Berhasil membuat organization baru!'
                }else{
                    url = `administrator/organization/${this.$route.params.id}/update`
                    method = 'PUT',
                    alertSuccess = 'Berhasil mengupdate organization!'
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: dataStored,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    const result = response.data;
                    if(result.success) {
                        this.sAlert('success', alertSuccess)
                        this.$router.push({ name: 'adminOrganization' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                    this.sAlert('error', error.response.data.message)
                });
            }
        },
        async mounted() {
            this.loadingInitial = true

            // LOAD DATA IF ROUTE IS EDIT
            if(this.$route.name == 'adminOrganizationEdit'){
                this.loadingInitial = true
                // LOAD DATA
                this.$http.get(`${this.API_URL}administrator/organization/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;
                    
                    if(result.success) {
                        this.dataOrganization.name = result.data.name
                        this.dataOrganization.code = result.data.code
                    }else {
                        this.sAlert('error', result.message)
                    }

                    this.loading = false;
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }

            this.loadingInitial = false
        }
    }
</script>